/**
 * Desktop chrome for the custom color picker. `design/GT Crew.dc.html`
 * `ccShow`; DESIGN-CHANGELOG 2026-08-18. 360px — the field is a square and
 * the modal is exactly as wide as the field wants to be. Markers stay
 * hoverable here (the tooltip layer names them); the written legend and the
 * footnote are the phone's, which has no hover. Body shared with the sheet.
 */

import { CustomColorBody } from '../../components/CustomColorBody.tsx';
import { useQd } from '../../store/index.ts';
import { Modal } from '../components/Modal.tsx';

export default function CustomColorModal(): JSX.Element | null {
  const s = useQd();
  if (!s.ccOpen) return null;
  return (
    <Modal
      width={360}
      label="Custom color picker"
      onClose={() => s.closeCc()}
      header={{ title: 'CUSTOM COLOR', note: 'HUE × LIGHTNESS' }}
    >
      <CustomColorBody desktop />
    </Modal>
  );
}
